import React, { useState } from "react";
import styled from "styled-components";

function HomeFAQ() {
    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        {
            q: "What digital marketing and IT services does DOAGuru InfoSystems offer?",
            a: "DOAGuru InfoSystems offers a complete range of Digital Marketing & IT Solutions including: SEO (Search Engine Optimisation), Google Ads & PPC, Social Media Marketing (Facebook, Instagram, LinkedIn), Content Marketing, Website Design & Development, Mobile App Development, Software Development, Graphic Designing, and Data Analysis. We serve businesses of all sizes across India.",
        },
        {
            q: "Does DOAGuru provide services outside Jabalpur? Do you work pan-India?",
            a: "Yes! DOAGuru InfoSystems serves businesses across all of India — Delhi, Mumbai, Bangalore, Hyderabad, Pune, Chennai, Bhopal, Indore, and beyond. All our Digital Marketing & IT services are delivered remotely with the same quality and dedication. Distance is no barrier for digital success.",
        },
        {
            q: "What is the cost of digital marketing services at DOAGuru?",
            a: "DOAGuru's digital marketing packages start from ₹8,000/month for small businesses (basic SEO + social media). Comprehensive packages range from ₹15,000 to ₹50,000+/month depending on services, competition, and goals. IT solutions like website development start from ₹15,000. Contact us for a FREE custom quote.",
        },
        {
            q: "How long does SEO take to show results?",
            a: "SEO is a long-term strategy. With DOAGuru's proven methods, most clients see initial keyword ranking improvements within 60-90 days. Significant organic traffic increase is typically visible within 4-6 months. Competitive national keywords may take 6-12 months. We provide monthly reports so you always know your progress.",
        },
        {
            q: "Is DOAGuru an IT company or a Digital Marketing company?",
            a: "DOAGuru InfoSystems is both! We are a full-service Digital Marketing & IT Solutions company. On the digital marketing side, we offer SEO, PPC, Social Media, and Content services. On the IT side, we develop websites, mobile apps, and custom software. This makes us a single-window solution for all your business's digital needs.",
        },
        {
            q: "How is DOAGuru different from other digital marketing agencies in India?",
            a: "DOAGuru InfoSystems stands out because: (1) We offer both Digital Marketing & IT under one roof, (2) We have 5+ years of proven experience with 100+ clients, (3) We provide dedicated account managers, (4) Monthly transparent reporting, (5) We are based in Jabalpur and understand tier-2 city business needs while serving national brands.",
        },
        {
            q: "Do you offer website development along with digital marketing?",
            a: "Yes! DOAGuru is a complete Digital Marketing & IT Solutions company. We build SEO-optimised websites, eCommerce stores, mobile apps, and custom software — and then promote them through our digital marketing services. Clients who use both services see 2-3x better results because website and marketing work together seamlessly.",
        },
        {
            q: "How can I get started with DOAGuru?",
            a: "Getting started is easy! Call us at +91-7440992424 or email info@doaguru.com. We offer a FREE website audit and FREE consultation for new clients. Our team will analyse your current digital presence, understand your goals, and propose a custom plan. No commitment required for the initial consultation.",
        },
        {
            q: "What results can I expect from DOAGuru's SEO services?",
            a: "Results vary by industry and competition, but typical DOAGuru clients experience: 40-60% increase in organic website traffic within 6 months, top 10 Google rankings for targeted keywords, 2-3x improvement in lead generation, and improved brand visibility online. We set realistic expectations from day one and share monthly progress reports.",
        },
        {
            q: "Does DOAGuru develop mobile apps for Android and iOS?",
            a: "Yes! DOAGuru InfoSystems develops high-performance mobile apps for both Android and iOS platforms. We build everything from MVP apps for startups to full-scale enterprise applications. Our apps are designed for seamless user experience, robust backend architecture, and scalable deployment. Get in touch for a FREE app consultation.",
        },
    ];

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <Wrapper>
            <div id="Faq">
                <div className="container">
                    <h2>Frequently Asked Questions (FAQs)</h2>
                    <div className="mt-4 shadow faqbox">
                        {faqs.map((faq, index) => (
                            <div key={index} onClick={() => toggleFAQ(index)} className="FAQItem">
                                <div className="d-flex align-items-start justify-content-between">
                                    <div className="d-flex align-items-start">
                                        <span>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                width="22"
                                                height="22"
                                                fill="currentColor"
                                                style={{
                                                    transition: "transform 0.3s ease",
                                                    transform: openIndex === index ? "rotate(90deg)" : "rotate(0deg)",
                                                }}
                                            >
                                                <path d="M8 5l8 7-8 7V5z" />
                                            </svg>
                                        </span>

                                        <h3>{faq.q}</h3>
                                    </div>

                                    <div className="icons">
                                        {openIndex === index ? (
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="10" height="10">
                                                <path
                                                    fill="currentColor"
                                                    d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 
                            17.67 14.33 32 32 32h384c17.67 0 32-14.33 
                            32-32v-32c0-17.67-14.33-32-32-32z"
                                                ></path>
                                            </svg>
                                        ) : (
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="10" height="10">
                                                <path
                                                    fill="currentColor"
                                                    d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 
                            0-32 14.33-32 32v144H32c-17.67 0-32 
                            14.33-32 32v32c0 17.67 14.33 32 32 
                            32h144v144c0 17.67 14.33 32 32 
                            32h32c17.67 0 32-14.33 
                            32-32V304h144c17.67 0 32-14.33 
                            32-32v-32c0-17.67-14.33-32-32-32z"
                                                ></path>
                                            </svg>
                                        )}
                                    </div>
                                </div>

                                {openIndex === index && <p className="Answer">{faq.a}</p>}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Wrapper>
    );
}

export default HomeFAQ;

const Wrapper = styled.div`
  #Faq {
    background-color: #ffffff;
    margin-top: 2.5rem;
    margin-bottom: 2rem;
    width: 95%;
    margin-left: auto;
    margin-right: auto;
    animation: fadeInUp 1s ease forwards;

    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(30px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @media (min-width: 1200px) {
      width: 90%;
    }

    @media (min-width: 1536px) {
      width: 80%;
    }
  }

  h2 {
    color: #0d1b2a;
    font-weight: 700;
    text-align: center;
    font-size: 1.75rem;
    margin-bottom: 1.5rem;
    letter-spacing: -0.5px;

    @media (min-width: 768px) {
      font-size: 2.25rem;
      margin-bottom: 2.5rem;
    }
  }

  .faqbox {
    background: #ffffff;
    border-radius: 20px;
    padding: 1.25rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
    border: 1px solid #f1f5f9;

    @media (min-width: 768px) {
      padding: 2.5rem 3rem;
    }
  }

  .FAQItem {
    border-bottom: 1px solid #f1f5f9;
    padding: 1.25rem 0.25rem;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-align: left;

    &:hover {
      background-color: #fafbfc;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      border-radius: 8px;
    }

    h3 {
      font-weight: 600;
      color: #1e293b;
      margin: 0;
      line-height: 1.5;
      font-size: 0.95rem;
      transition: color 0.2s ease;

      @media (min-width: 576px) {
        font-size: 1.05rem;
      }

      @media (min-width: 768px) {
        font-size: 1.15rem;
      }
    }

    &:last-child {
      border-bottom: none;
      &:hover {
        border-bottom: none;
      }
    }
  }

  span {
    margin-right: 0.6rem;
    display: flex;
    align-items: center;
    color: #1e293b;

    @media (min-width: 576px) {
      margin-right: 1rem;
    }
  }

  .icons {
    min-width: 22px;
    min-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #ffffff;
    border: 2px solid #1e293b;
    transition: all 0.3s ease-in-out;
    flex-shrink: 0;
    color: #1e293b;

    @media (min-width: 768px) {
      min-width: 26px;
      min-height: 26px;
    }

    svg {
      color: currentColor;
      font-size: 14px;
      transition: all 0.3s ease-in-out;

      @media (min-width: 768px) {
        font-size: 16px;
      }
    }
  }

  .FAQItem:hover .icons {
    border-color: #fe7604;
    background-color: #fe7604;
    color: #ffffff;
  }

  .FAQItem:hover h3 {
    color: #fe7604;
  }

  .Answer {
    margin-top: 0.75rem;
    color: #475569;
    font-size: 0.875rem;
    line-height: 1.6;
    text-align: left;
    overflow: hidden;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    animation: slideDown 0.4s ease-out;
    margin-left: 2rem;

    @media (min-width: 768px) {
      margin-left: 2.85rem;
      font-size: 0.95rem;
    }

    @keyframes slideDown {
      from {
        opacity: 0;
        max-height: 0;
        transform: translateY(-8px);
      }
      to {
        opacity: 1;
        max-height: 500px;
        transform: translateY(0);
      }
    }
  }
`;
